import { useContext, useState } from 'react';
import PageContext from './PageContext';
import WorkflowCommentLog from '../sub-components/WorkflowCommentLogCopy';
import { HttpContext } from '../../api-services/HttpService';
import CCOffcanvas from "./CCOffcanvas.tsx";
import ButtonComponent from "../sub-components/ButtonComponent"
import  '../../css/offcanvasStyle.css'; 
import EllipsisInfoLabel from './EllipsisInfoLabel.jsx';

const RebateCommentModal = () => {
    // get context variables from parent
    const {
        commentModal,
        setCommentModal,
        editRow,
    } = useContext(PageContext);
    // initialize http context 

    const {
        GET,
    } = useContext(HttpContext);

    // initialize state
    const [commentText, setCommentText] = useState('');

    // create function for creating a new comment
    const createComment = (workflowid, commenttype, commenttext) => {
        return new Promise((resolve, reject) => {
            GET('/rebate/summary/comment/new', { workflowid: workflowid, commenttype: commenttype, commenttext: commenttext })
                .then(res => {
                    resolve(res);
                }).catch(err => {
                    console.log(err);
                    reject(err);
                });
        })
        //.then(getUserEntitlements(user))  
    }

    const onSubmitClick = () => {
        createComment(editRow.workflowid, editRow.userroleid, commentText)
        //close modal
        setCommentModal(commentModal => commentModal = false);
        //reset comment text to blank incase user returns to make another comment
        setCommentText(commentText => commentText = '');
    }

    return (
        <CCOffcanvas
            title={"Edit Comment"}
            show={commentModal}
            onCanvasClose={() => {setCommentText(''); setCommentModal(false)}}
            bodyCssClassName="offcanvas-body"
            offCanvasClassName="offcanvas-parent-card"
        >
            {/* read only input for info on rebate workflow that is being viewed */}
            <div className="bg-white p-3" style={{fontSize: '14px'}}>
                <div className="d-flex gap-3 flex-wrap">
                    <EllipsisInfoLabel title={'Company Name:'} content={editRow.mastercompanyname} maxChar='50'/>
                    <div className="vr"></div>
                    <EllipsisInfoLabel title={'Payout Cycle:'} content={editRow.periodcyclestart + '-' + editRow.periodcycleend + ' [' + editRow.incentivefreq + ']'} maxChar='20'/>
                </div>
            </div>
            {/* comment log to show all comments attached to rebate workflow */}
            <div className="p-3 comment-section">
                <div className="bg-white comment-card" >
                    <WorkflowCommentLog workflowid={editRow.workflowid} />
                    {/* textarea input for new comment */}

                    <div className="p-3" style={{borderTop: "1px solid #ECECEC"}}>
                        <input className="w-100 input-text-field" value={commentText} onChange={(e) => setCommentText(commentText => commentText = e.target.value)} placeholder='Type comments here'></input>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end p-3 w-100 position-absolute bottom-0 offcanvas-footer">
                    <ButtonComponent tag={"Cancel"} 
                        border={'#fcd800 1px solid'} background={'#fff'} color={'#001317'} 
                        onButtonClick={() => {setCommentText(''); setCommentModal(false)}}
                    />
                    <ButtonComponent tag={"Submit"}
                        border={'#fcd800 1px solid'} background={'#fcd800'} color={'#001317'}
                        onButtonClick={onSubmitClick}
                    />
            </div>
        </CCOffcanvas>
    );
}

export default RebateCommentModal;